import { NgModule } from '@angular/core';
import { AppShotfooterComponent } from '../app-shotfooter/app-shotfooter.component';
import { TranslateServiceModule } from '../translate-service/translate-service.module';



@NgModule({
  declarations: [
    AppShotfooterComponent
  ],
  imports: [
    TranslateServiceModule
  ],
  exports:[
    AppShotfooterComponent
  ]
})
export class ShotFooterModule { }
